module.exports = __webpack_public_path__ + "static/media/users2.4b8afc90.svg";